<template>
    <sa-page-layout titolo="AnDIamo - Dettaglio Utente" class="sa-no-space" btnRouterBackVisible btnRefreshVisible @refresh="onRefresh">
        <template slot="table-body">
            <AndiamoUtenteViewComponent ref="cmpAndiamoUtenteViewComponent" @disattiva="onDisattiva" @riattiva="onRiattiva" />
        </template>
    </sa-page-layout>
</template>

<script>
import SaPageLayout from "../../../template/sa/components/layout/contents/SaPageLayout.vue";
import AndiamoUtenteViewComponent from "../components/AndiamoUtenteViewComponent.vue";

export default {
    components: { SaPageLayout, AndiamoUtenteViewComponent },
    methods: {
        onRefresh() {
            this.$refs.cmpAndiamoUtenteViewComponent.loadData();
        },
        onDisattiva(utente) {
            this.$bvModal.msgBoxConfirm("Disattivare l'utente " + utente.codiceFiscaleOperatore + "?", { title: "Conferma", okVariant: "danger" }).then((conferma) => {
                if (conferma) {
                    this.$refs.cmpAndiamoUtenteViewComponent.andiamoDisattivaUtente(utente.codiceFiscaleOperatore, null, null, () => {
                        this.$bvToast.toast("Utente disattivato", { title: "", variant: "success", solid: true });
                        this.$refs.cmpAndiamoUtenteViewComponent.loadData();
                    });
                }
            });
        },
        onRiattiva(utente) {
            let oggi = new Date().toISOString().slice(0, 10);
            let body = {
                codiceFiscaleOperatore: utente.codiceFiscaleOperatore,
                nome: utente.nome,
                cognome: utente.cognome,
                telefono: utente.telefono,
                email: utente.email,
                gender: utente.gender,
                tipoOperatoreCode: utente.tipoOperatoreCode,
                tipoOperatoreDisplay: utente.tipoOperatoreDisplay,
                dataInizio: oggi,
            };
            this.$refs.cmpAndiamoUtenteViewComponent.andiamoModificaUtente(utente.codiceFiscaleOperatore, body, () => {
                this.$bvToast.toast("Utente riattivato", { title: "", variant: "success", solid: true });
                this.$refs.cmpAndiamoUtenteViewComponent.loadData();
            });
        },
    },
};
</script>

<style lang="scss" scoped></style>
